import React, { useCallback, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppRoutes from './routes';
import {
  ADS_LANDING_ROUTE,
  LOGGED_OUT_ORDER_EXPENSE_REQUEST_ACTION_ROUTE,
  LOGGED_OUT_ONLINE_PAYMENTS,
  LOGGED_OUT_SUCCESS,
  LOGGED_OUT_EXPENSE_REQUEST_ACTION_ROUTE,
  GIFT_CARD_ROUTE,
  LANDING_ROUTE,
} from './constants/routes';
import LoggedOutOnlinePaymentsPage from './pages/Payments/LoggedOutOnlinePaymentsPage';
import LoggedOutPaymentSuccessPage from './pages/Payments/LoggedOutOnlinePaymentsPage/LoggedOutPaymentSuccessPage/LoggedOutPaymentSuccessPage';
import JumboClient from './jumbo/JumboClient';
import ExpenseActionPage from './pages/Orders/ExpenseActionPage';
import Landing from './pages/Landing';
import { getUUID } from './helpers';
import GiftCardPage from './pages/GiftCardPage';

const App = () => {
  useEffect(() => {
    initilizeJumboLogging();
  });

  const initilizeJumboLogging = useCallback(() => {
    JumboClient.setHeaders();
    JumboClient.setParams({ session_id: getUUID() });
  }, []);

  if (window.location.pathname.startsWith('/dashboard')) {
    return <AppRoutes />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={LOGGED_OUT_ONLINE_PAYMENTS}
          element={<LoggedOutOnlinePaymentsPage />}
        />
        <Route
          path={LOGGED_OUT_SUCCESS}
          element={<LoggedOutPaymentSuccessPage />}
        />
        <Route
          path={LOGGED_OUT_ORDER_EXPENSE_REQUEST_ACTION_ROUTE}
          element={<ExpenseActionPage />}
        />
        <Route
          path={LOGGED_OUT_EXPENSE_REQUEST_ACTION_ROUTE}
          element={<ExpenseActionPage />}
        />
        <Route path={GIFT_CARD_ROUTE} element={<GiftCardPage />} />
        <Route
          path={ADS_LANDING_ROUTE}
          element={<Landing scrollToFold={2} noIndex />}
        />
        <Route
          path={LANDING_ROUTE}
          element={<Landing />}
        />
        <Route path='*' element={<Navigate to={LANDING_ROUTE} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
